import { render, staticRenderFns } from "./admin-tn-tools.vue?vue&type=template&id=1bd5196d&scoped=true&"
import script from "./admin-tn-tools.vue?vue&type=script&lang=js&"
export * from "./admin-tn-tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5196d",
  null
  
)

export default component.exports